export default function (callback, id, action, options = {}) {
    const domNodeExist = document.getElementById(id);
    if (!domNodeExist) {
        const container = document.createElement('div');
        container.setAttribute('id', id);
        document.body.appendChild(container);
        callback(container, options);
    }
    action && action();
}

export const injectIntoContainer = (callback, id, action, options) => {
    const domNodeExist = document.getElementById(id);
    if (domNodeExist) {
        callback(domNodeExist, options);
    }
    action && action();
};